module.exports = __webpack_public_path__ + "img/450bb1d.svg";